import { TOGGLE_SIDEBAR } from "./types";

export const toggleSidebar = (value) => {
    
    return {
        type: TOGGLE_SIDEBAR,
        payload: value
    }
};